import { render, staticRenderFns } from "./BlockNotification.vue?vue&type=template&id=b301b5ce&scoped=true&"
import script from "./BlockNotification.vue?vue&type=script&lang=js&"
export * from "./BlockNotification.vue?vue&type=script&lang=js&"
import style0 from "./BlockNotification.vue?vue&type=style&index=0&id=b301b5ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b301b5ce",
  null
  
)

export default component.exports